import React, { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Input, Button, Modal, message } from 'antd';
import Validator from '@/views/account/utils/formValidator';
import { GAForgotPasswordClickConfirm } from '@/views/account/ga/forgotPassword';
import { checkGoogleSafe, requsetGetCode } from '@/views/account/api/apis';
import i18n from '@/locales/i18n';
import '@/views/account/assets/forgotAndResetPassWordModal.scss';
import Cookies from 'js-cookie';
import { useEffect } from 'react';

const Security = ({ email, visible, googleID, handleCancel }) => {
  const { t } = useTranslation(['loginAndSignUp', 'common']);
  const [codeCountDownTimeSec, setCodeTime] = useState(0);
  const [isClock, setIsClock] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [codeToken, setCodeToken] = useState('');
  const [form] = Form.useForm();
  let timer = useRef(null); //定时器

  /**
   * 渲染验证码输入框的获取验证码按钮的方法
   * @returns 返回验证码输入框的获取验证码按钮
   */

  const checkSafe = () => {
    let code = form.getFieldValue('verification');
    console.log(codeToken);
    let params = {
      email: email,
      code: code,
      codeToken: codeToken,
      googleID: googleID,
    };
    handleSubmit(params);
  };

  const handleSubmit = (params) => {
    setSubmitLoading(true);
    const { email, code, codeToken, googleID } = params;
    checkGoogleSafe({
      email: email,
      code: code,
      token: codeToken,
      id: googleID,
    }).then((obj) => {
      console.log(obj);
      if (obj.code === 200) {
        Cookies.set('authorization', obj.data.authorization, { expires: 30 });
        window.location.reload();
      } else {
        if (obj.msg) {
          message.error(obj.msg);
        }
      }
      setSubmitLoading(false);
    });
  };
  const handleRequsetGetCode = () => {
    let formData = new FormData();
    formData.append('email', email.replace(/(^\s*)|(\s*$)/g, ''));
    formData.append('is_validate', 1);
    requsetGetCode({
      body: formData,
    }).then((res) => {
      setCodeTime(60);
      setIsClock(true);
      if (res.code === 200) {
        message.success(i18n.t('loginAndSignUp:getCodeSuccessTips'));
        setCodeToken(res.data.token);
      }
    });
  };

  useEffect(() => {
    if (isClock) {
      timer.current = setInterval(() => {
        setCodeTime((prev) => {
          if (prev - 1 < 0) {
            setIsClock(false);
          }
          console.log(prev - 1);
          return prev - 1;
        });
      }, 1000);
    } else {
      setCodeTime(0);
      clearTimeout(timer.current);
    }
  }, [isClock]);
  const renderGetCodeBtn = () => {
    return codeCountDownTimeSec === 0 ? (
      <span className='text-primary' onClick={() => handleRequsetGetCode()}>
        {t('getCode')}
      </span>
    ) : (
      <span className='text-primary' style={{ cursor: 'not-allowed' }}>
        {codeCountDownTimeSec} s
      </span>
    );
  };

  return (
    <Modal
      centered
      maskClosable={false}
      visible={visible}
      title={null}
      footer={null}
      width={500}
      onCancel={() => handleCancel()}
    >
      <div className='forget-and-reset-cont p-md-4 p-0'>
        <h4 className='fw-bold mb-4'>
          {t('loginAndSignUp:Securityverification')}
        </h4>
        <p
          style={{
            fontSize: 16,
            fontWeight: 400,
            fontFamily: 'Poppins',
          }}
        >
          {t('loginAndSignUp:youraccount')} ({email}){' '}
          {t(
            'loginAndSignUp:alreadyexiststoensurethesecuritypleaseverifyitfirst'
          )}
        </p>
        <Form
          form={form}
          layout='vertical'
          //  ref={form}
          validateTrigger='onBlur'
          name='forgot-password'
          className='w-100'
          onFinish={checkSafe}
        >
          <Form.Item name='email' initialValue={email}>
            <Input placeholder={t('common:email')} allowClear readOnly />
          </Form.Item>
          <Form.Item
            name='verification'
            rules={[
              {
                required: true,
                formName: 'forgot_password',
                validator: Validator.emptyValidator,
              },
            ]}
          >
            <Input
              className='verification-input'
              placeholder={t('common:verificationCode')}
              addonAfter={renderGetCodeBtn()}
            />
          </Form.Item>
          <Form.Item className='mb-0'>
            <Button
              loading={submitLoading}
              className='fs-6 fw-bolder submit-btn py-2'
              style={{ minWidth: '100%' }}
              type='primary'
              htmlType='submit'
              size='large'
            >
              {t('confirm')}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};

export default Security;
